module.exports = __webpack_public_path__ + "img/file-earmark-texts.a71f46c8.png";